import { useMarketplaceConfig } from '../queries/marketplace';

export const useBetBuilderFeature = () => {
  const { data: marketplaceConfig } = useMarketplaceConfig();

  return marketplaceConfig?.sportsbookConfig?.betBuilder ?? true;
};
